export function getContainerStyles(layout) {
    const style = {
        overflowX: 'hidden',
        overflowY: 'hidden',
        height: '100%',
        display: 'flex',
        flexShrink: 1,
        position: 'relative',
    };
    if (layout.scrollbars) {
        if (layout.scrollbars.horizontal) {
            style.overflowX = 'scroll';
        }
        if (layout.scrollbars.vertical) {
            style.overflowY = 'scroll';
        }
    }
    return style;
}
